
import React, { Suspense } from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import PageLoadingSpinner from '@/components/common/PageLoadingSpinner';
import {
  LazyMain,
  LazyDashboard,
  LazyClients,
  LazyOrders,
  LazyRentals,
  LazyInventory,
  LazyStore,
  LazySettings,
  LazyTasks,
  LazyReports,
  LazySearchResults,
  LazyNotifications,
} from './lazyRoutes';

const withSuspense = (
  Component: React.LazyExoticComponent<React.ComponentType<Record<string, never>>>,
  fallbackMessage?: string
) => {
  return (
    <Suspense fallback={<PageLoadingSpinner message={fallbackMessage} />}>
      <Component />
    </Suspense>
  );
};

export const getCoreProtectedRoutes = (): JSX.Element[] => [
  <Route key="main" path="/main" element={
    <ProtectedRoute>
      <Navigate to="/dashboard" replace />
    </ProtectedRoute>
  } />,
  <Route key="dashboard" path="/dashboard" element={
    <ProtectedRoute>
      {withSuspense(LazyDashboard, "Загрузка панели управления...")}
    </ProtectedRoute>
  } />,
  <Route key="clients" path="/clients" element={
    <ProtectedRoute>
      {withSuspense(LazyClients, "Загрузка списка клиентов...")}
    </ProtectedRoute>
  } />,
  <Route key="orders" path="/orders" element={
    <ProtectedRoute>
      {withSuspense(LazyOrders, "Загрузка заказов...")}
    </ProtectedRoute>
  } />,
  <Route key="rentals" path="/rentals" element={
    <ProtectedRoute>
      {withSuspense(LazyRentals, "Загрузка аренд...")}
    </ProtectedRoute>
  } />,
  <Route key="inventory" path="/inventory" element={
    <ProtectedRoute>
      {withSuspense(LazyInventory, "Загрузка инвентаря...")}
    </ProtectedRoute>
  } />,
  <Route key="store" path="/store" element={
    <ProtectedRoute>
      {withSuspense(LazyStore, "Загрузка магазина...")}
    </ProtectedRoute>
  } />,
  <Route key="settings" path="/settings" element={
    <ProtectedRoute>
      {withSuspense(LazySettings, "Загрузка настроек...")}
    </ProtectedRoute>
  } />,
  <Route key="tasks" path="/tasks" element={
    <ProtectedRoute>
      {withSuspense(LazyTasks, "Загрузка задач...")}
    </ProtectedRoute>
  } />,
  <Route key="reports" path="/reports" element={
    <ProtectedRoute>
      {withSuspense(LazyReports, "Загрузка отчетов...")}
    </ProtectedRoute>
  } />,

  <Route key="search" path="/search" element={
    <ProtectedRoute>
      {withSuspense(LazySearchResults, "Поиск...")}
    </ProtectedRoute>
  } />,
  <Route key="notifications" path="/notifications" element={
    <ProtectedRoute>
      {withSuspense(LazyNotifications, "Загрузка уведомлений...")}
    </ProtectedRoute>
  } />
];
